import React from "react";
import { useParams } from "react-router-dom";
import SwitchCourseBoard from "../../../../../components/montessori-course-board/SwitchCourseBoard";

/** Read-only for instructors — the shared component hides authoring by role. */
function InstructorCourseBoardView() {
  const { classId } = useParams();
  return <SwitchCourseBoard classId={classId} />;
}

export default InstructorCourseBoardView;
